{
  "Manage multiple offices with ease.": "Manage multiple offices with ease.",
  "Office Locations": "Office Locations"
}
